module.exports = __webpack_public_path__ + "img/mary-pily-loo.0a5e3792.png";